/* Forest — egyszerre EGY kosárfiók élhet, és a fejléc számlálója kövesse.
 *
 * ── 1. A KÉT FIÓK ────────────────────────────────────────────────────────
 * Bekapcsolt UpCart mellett a téma saját `<cart-drawer>`-e is teljesen élő
 * maradt. Mérve 2026-08-26 a build témán, CSAK valódi kattintásokkal, mobilon:
 *
 *   1. üres kosár, PDP betöltve   ->  upcart=csukva  tema=csukva
 *   2. „Kosárba" megnyomva        ->  upcart=NYITVA  tema=NYITVA   <- MINDKETTŐ
 *   3. X-szel bezárva             ->  upcart=csukva  tema=NYITVA   <- ott marad
 *                                     body.overflow=hidden          <- és zár
 *   5. kosárikonra kattintva      ->  upcart=csukva  tema=NYITVA
 *
 * Innen jött a „nem tudom bezárni": az UpCart bezárult, a téma fiókja nem, és
 * ő tartotta a `body.overflow-hidden`-t, mert a `close()`-ja soha nem futott.
 *
 * MIÉRT NEM TÖRÖLJÜK AZ ELEMET. A product-form.js így dönt:
 *     this.cart = querySelector('cart-notification') || querySelector('cart-drawer')
 *     else if (!this.cart) { window.location = routes.cart_url; return; }
 * Elem nélkül a kosárba tétel ÁTNAVIGÁLNA a /cart lapra. Az elem marad, csak
 * az `open()` no-op: a `renderContents()` tovább frissíti a tartalmát, de nem
 * jelenik meg és nem zár görgetést.
 *
 * ── 2. A FEJLÉC SZÁMLÁLÓJA ───────────────────────────────────────────────
 * A kosárba tételt bekapcsolt UpCart mellett AZ APP végzi, nem a
 * product-form.js — tehát a Dawn `cartUpdate` pubsub-ja nem szól, és a
 * drl-cart.js `refreshCartCount`-ja nem fut le. Mérve ugyanott:
 *
 *     ATC után:  szerver item_count=2,  badge.text="0"  is-hidden=true
 *                .hglass__cart  display:none
 *
 * A fejléc kosárlinkje `:has(.hglass__cart-count.is-hidden)`-re rejtőzik, tehát
 * kosárba tétel után NEM VOLT MIT MEGNYOMNI — ez volt a „mobilon a kosárra
 * kattintva nem jön be" másik fele.
 *
 * Az appnak nincs publikus kosár-eseménye (a bundle-ben csak
 * `upcart:discount-apply/remove` és egy `aftersell-upcart-debug` debug-csatorna
 * van), ezért a jelet abból vesszük, ami biztosan mozog: az UpCart shadow
 * rootja újrarendel minden kosárváltozásnál. Onnan viszont NEM olvasunk
 * darabszámot — a hiteles forrás a `/cart.js`. Egy megfigyelő, késleltetve.
 */
(function () {
  // ── 1. a téma fiókja ne nyíljon ki ──────────────────────────────────────
  customElements.whenDefined('cart-drawer').then(function () {
    var C = customElements.get('cart-drawer');
    if (!C || C.prototype.__drlSolo) return;
    C.prototype.__drlSolo = true;
    C.prototype.open = function () {
      // Ha egy korábbi nyitás már kitette a zárat, vegyük is le.
      document.body.classList.remove('overflow-hidden');
    };
  });

  // ── 2. a fejléc kosárlinkje nyissa az UpCartot ──────────────────────────
  // MIÉRT KELL EZ. Az app beállítása (mérve a lapra injektált blokkból):
  //     openCartButtonSelection = {"option":"custom-selector",
  //                                "customSelector":"[aria-controls=\"site-cart-sidebar\"]"}
  // A `custom-selector` LECSERÉLI az UpCart teljes alapértelmezett szelektor-
  // listáját erre az egyre — és ez a RÉGI élő téma kosár-sidebarjára mutat.
  // A Forest fejlécén nincs ilyen attribútum, tehát az UpCart a `.hglass__cart`-ra
  // EGYETLEN figyelőt sem tett (mérve: DOMDebugger.getEventListeners -> üres),
  // a kattintás pedig szépen elnavigált a /cart lapra.
  //
  // Nem az appot állítjuk át: az a beállítás az ÉLŐ témával közös, és a live
  // most is arra a szelektorra támaszkodik. Cutover után ott a helyes lépés
  // `default-selector`-ra (vagy `additional-selector`-ra) váltani; addig a téma
  // nyitja meg magának, az app publikus `window.upcartOpenCart()`-jával.
  //
  // Nem teszünk hamis `aria-controls`-t a linkre csak azért, hogy az app
  // szelektora fogja: egy sehova nem mutató idref akadálymentességi hiba lenne.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.hglass__cart');
    if (!link) return;
    if (typeof window.upcartOpenCart !== 'function') return;  // marad a /cart link
    e.preventDefault();
    window.upcartOpenCart();
  });

  // ── 3. a fejléc számlálója kövesse a szervert ───────────────────────────
  var timer = null;
  var last = null;

  function paint(count) {
    if (typeof count !== 'number' || count === last) return;
    last = count;
    var badge = document.querySelector('.hglass__cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('is-hidden', count === 0);
    // A feliratot NEM írjuk újra, csak a benne álló számot cseréljük — így a
    // fordítás marad, amit a Liquid tett ki. Magyar szöveg nem kerül kódba.
    var link = document.querySelector('.hglass__cart');
    var label = link && link.getAttribute('aria-label');
    if (label) link.setAttribute('aria-label', label.replace(/\(\d+\)/, '(' + count + ')'));
  }

  function refresh() {
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paint(c.item_count); })
      .catch(function () {});
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(refresh, 400);
  }

  // A shadow root a bundle futásakor jön létre, ami ennél a `defer` scriptnél
  // később fut. NEM foltozzuk az attachShadow-t: azt a drl-upcart-glass.js már
  // megteszi, és két egymásra épülő folt a globális prototípuson pontosan az a
  // fajta törékenység, amiből a mai hibák jöttek. A számlálónak nem kell
  // villanásmentes időzítés — megvárjuk a rootot, felső korláttal.
  var waited = 0;
  (function waitForRoot() {
    var host = document.getElementById('upCart');
    var root = host && host.shadowRoot;
    if (root) {
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      schedule();
      return;
    }
    if ((waited += 250) > 15000) return;   // az app nem jött — nincs mit figyelni
    setTimeout(waitForRoot, 250);
  })();
})();
